import { Component , Output, EventEmitter, Input} from '@angular/core';
import { FloatingItem } from './floatingbar-item';
import { FALSE } from '../../../utils/config/const';


@Component({
  selector: 'app-floatingbar',
  templateUrl: './floatingbar.component.html',
  styleUrls: ['./floatingbar.component.scss']
})
export class FloatingbarComponent {

    @Input() items:FloatingItem[];
    @Input() toggleParam: boolean = false;
    @Output() choiceButton = new EventEmitter<string>();


  public  statusButtonOpen:boolean = false;

  clickChoiceButton(value: string) {
    this.choiceButton.emit(value);
  }

  toggleButton(){
    if (this.toggleParam == FALSE) {
      this.statusButtonOpen = !this.statusButtonOpen;
    }else{
      if(this.items != null && typeof this.items != typeof undefined){
        if(this.items.length > 0){
          this.clickChoiceButton(this.items[0].choice);
        }
      }
    }
  }

}
